<ng-container>
  <div class="row mt-4 login-container">
    <div class="col-9 px-2">
      <p class="c-g-headers fw-bold fs-4">Sign in to your CGP Books account</p>
      <div class="mt-5">
        @if (!isAlreadyLoggedIn()) {

          <p>Don’t have an account? Create one <a href="{{environment.app.mediaBaseUrl}}/register?ReturnUrl={{environment.security.baseUrl}}/registration">here</a>.</p>

          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
            <div class="mb-3">
              <label for="username" class="form-label">Email address or Username <span class="text-danger">*</span></label>
              <input type="text" id="username" formControlName="username" class="form-control"
                     [class.is-invalid]="submitted && f['username'].errors"/>
              @if (submitted && f['username'].errors) {
                <div class="invalid-feedback">
                  Username is required.
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
              <input type="password" id="password" formControlName="password" class="form-control"
                     [class.is-invalid]="submitted && f['password'].errors"/>
              @if (submitted && f['password'].errors) {
                <div class="invalid-feedback">
                  Password is required.
                </div>
              }
            </div>
            <button type="submit" class="btn default-cgp-btn" [disabled]="isLoading || loginForm.invalid || isAlreadyLoggedIn()">
              @if (!isLoading) {
                <span>Sign in</span>
              }
              @if (isLoading) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              }
            </button>

            @if (errorMessage) {
              <div class="alert alert-danger mb-3 mt-4" role="alert" [innerHTML]="errorMessage">
              </div>
            }

            @if (showSuccess()) {
              <div class="alert alert-success mb-3 mt-4" role="alert">
                Login successful! Redirecting to the landing page...
              </div>
            }

          </form>
        }
        @if (isAlreadyLoggedIn()) {
          <div class="already-signed-in mb-3" role="status">
            You are already signed in.
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
